<template>
<div class="m-auto shared-entities-list">
    <div v-for="entity in displayed_entities" :key="entity.id"  :class="[get_folder_color_class(entity)]" class="d-flex align-items-center justify-content-start gap-1 py-2 px-3 my-1 bg-grey-100" style="border-radius: 5px;" :title="entity.name">
        <i v-if="entity.entity_type == NamespaceService.ENTITY_TYPE_FOLDER" class="ion-folder icon-lg d-inline-block mr-1" ></i>
        <img v-else class="thumb32" :src="entity.name | extension | filetype_img_src" />
        <div>{{ entity.name }}</div>
    </div>
    <section v-if="entities.length > max_files_to_show && !show_all_entities" class="text-center mt-1">
        <a href="#" @click.prevent="show_all_entities = true" class="text-inherit text-sm">Show all {{ entities.length }} files</a>
    </section>
</div>
</template>
<script lang="js">

import { Utils } from '@/helpers/utils';
import { NamespaceService } from '@/services/namespace-service';

/**
 * Shows a list of files/folder that are part of a Share.
 * If more than `max_files_to_show` files are shared, the rest are hidden and a button allows showing them
 */
export default {
    props: {
        entities: Array,
        max_files_to_show: {
            // How many files to show if there are lots of them
            type: Number, default: 5
        }
    },

    data(){
        return {
            NamespaceService: NamespaceService,
            show_all_entities: false
        }
    },

    computed: {
        displayed_entities(){
            return this.show_all_entities ? this.entities : this.entities.slice(0, this.max_files_to_show)
        }
    },

    methods: {
        entity_name_has_extension(entity){
            // Returns whether the given entity has an extension, which should not be clipped
            return entity.entity_type != NamespaceService.ENTITY_TYPE_FOLDER && this.$options.filters.remove_extension(entity.name) != entity.name
        },

        get_folder_color_class(entity){
            return entity.entity_type == NamespaceService.ENTITY_TYPE_FOLDER ? `color-${Utils.string_to_color(entity.name)}-400` : ''
        }
    }

}

</script>
<style>
/* Dark mode styling */
.theme-dark .shared-entities-list div,
.theme-ironshard .shared-entities-list div{
    background: #546e7a; /* bg-blue-grey-600 */
    color: white
}
</style>